<template>
  <div>
    <v-card>
      <v-row>
        <v-col>
          <v-card-title>Employee Statutory Informations Import</v-card-title>
        </v-col>

        <v-col
          cols="2"
          class="ma-auto"
        />

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                href="/templates/Employee Contribution Template.xlsx"
                color="hrissuccess"
                dark
                icon
                medium
                v-on="{ ...tooltip }"
              >
                <v-icon class="mr-1">
                  mdi-download
                </v-icon>
              </v-btn>
            </template>
            <span>Employee Statutory Informations Import Template</span>
          </v-tooltip>

          <import-payroll-employee-contribution-dialog-import />
        </v-col>
      </v-row>
    </v-card> 
  </div>
</template>

<script>
  export default {
    components: {
      ImportPayrollEmployeeContributionDialogImport: () => import('@/components/hris/import/payroll/employee-contribution/DialogImport'),
    },
  }
</script>
